module.exports = __webpack_public_path__ + "static/webmail_p-b90bad109b4148bb10a3767bf795c0c3.png";